/* eslint-disable no-param-reassign */
export default (
  state,
  {
    meta: {
      arg: { id, file, bucket },
    },
  }
) => {
  state[id] ??= {
    id,
    fileSize: file.size,
    fileName: file.name,
    bucket,
    progress: 0,
    uploadSize: 0,
    uploading: true,
    failed: false,
    canceling: false,
    uploaded: false,
  };
};
